module.exports = __webpack_public_path__ + "static/media/005.8a3b96b9.jpg";